import React from 'react';
import { Field, TextInput, TextArea } from '../lib/FormControls';

export default function Step10AgentComments({ form, setField }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Agent Comments</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field label="Agent Name / Code" required>
          <TextInput
            value={form.agent_name_code}
            onChange={(e) => setField('agent_name_code', e.target.value)}
          />
        </Field>
        <Field label="Split Agent Name / Code">
          <TextInput
            value={form.split_agent_name_code}
            onChange={(e) => setField('split_agent_name_code', e.target.value)}
          />
        </Field>
        <Field label="Agent Carrier">
          <TextInput
            value={form.agent_carrier}
            onChange={(e) => setField('agent_carrier', e.target.value)}
          />
        </Field>
        <Field label="Agent Indexed Strategies">
          <TextInput
            value={form.agent_indexed_strategies}
            onChange={(e) => setField('agent_indexed_strategies', e.target.value)}
          />
        </Field>
      </div>
      <Field label="Other Comments">
        <TextArea
          rows={4}
          value={form.agent_other_comments}
          onChange={(e) => setField('agent_other_comments', e.target.value)}
        />
      </Field>
    </div>
  );
}
